import useSegmentedTest from 'hooks/useSegmentedTest';
import useCustomer from 'stores/customer';
import useFidelity from 'stores/fidelity';
import { BONI_CONFIG, calculateBoniPoints, formatBoniPoints, truncateBoniPoints } from '../helpers';
import { useMemo } from 'react';
import features from 'config/featureFlags';

export default function useBoniVisibility(value?: number) {
	const {
		fidelityStore: {
			data: { isNetwork, levelName, level },
		},
		navigateToFidelityPage,
	} = useFidelity();

	const {
		customerStore: {
			data: { hyperaRole },
		},
		simulatedViewType,
	} = useCustomer();

	const bannerVersion = useSegmentedTest('BONI_CART_BANNER');
	const isValidBannerVariation = bannerVersion === 'BONI_CART_COMPACT' || bannerVersion === 'BONI_CART_DEFAULT';
	const compactBanner = bannerVersion === 'BONI_CART_COMPACT';

	const isSimulated = !!simulatedViewType();

	const boniPoints = truncateBoniPoints(levelName ? calculateBoniPoints(levelName, value) : 0);

	const formatPoints = formatBoniPoints(boniPoints);

	const showBoniPoints =
		features.BONI_POINTS_CART &&
		useSegmentedTest('BONI_CART') &&
		!isNetwork &&
		!isSimulated &&
		!hyperaRole &&
		boniPoints > 0;

	const showBoniBanner =
		features.BONI_POINTS_CART && isValidBannerVariation && !levelName && !hyperaRole && !isSimulated;

	const levelConfig = BONI_CONFIG[levelName];
	const cashbackPercentage = (BONI_CONFIG[levelName]?.percentage ?? 0) * 100;

	return {
		level,
		levelName,
		boniPoints,
		levelConfig,
		formatPoints,
		compactBanner,
		showBoniBanner,
		showBoniPoints,
		cashbackPercentage,
		navigateToFidelityPage,
	};
}
